import styled from '@emotion/styled';
import { HEADER_COLOR } from '@/styles';

const CountryAsTextContainer = styled.p`
  color: ${HEADER_COLOR};
  font-size: 14px;
  font-weight: 600;
`;

export { CountryAsTextContainer };
